import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared/types';
import type {
  LC_CreateEmployeeContractIn,
  LC_CreateEmployeeContractOut,
} from '../types/employeeContractCreate.types';


export class EmployeeContractCreateService {
  /**
   * Creates a new employee contract
   * POST /v{version}/employees/{employeeId}/contracts
   * @param employeeId - Employee ID
   * @param input - Contract data
   */
  async create(
    employeeId: number,
    input: LC_CreateEmployeeContractIn,
  ): Promise<ApiResponse<LC_CreateEmployeeContractOut>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_CONTRACT.CREATE(employeeId);
    return apiClient.post<LC_CreateEmployeeContractOut>(endpoint, input);
  }
}

export const employeeContractCreateService = new EmployeeContractCreateService();
